export default __webpack_public_path__ + "static/media/skejuul.4065c156.png";